import { render, staticRenderFns } from "./BusinessesChange.vue?vue&type=template&id=6998477e"
import script from "./BusinessesChange.vue?vue&type=script&lang=js"
export * from "./BusinessesChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports